import { useEffect } from "react";

/**
 * Bootstrap guest referral localStorage from URL search params.
 */
export function useGuestReferralStorage(searchParams) {
  useEffect(() => {
    localStorage.setItem(
      "selectedState",
      JSON.stringify({ value: "FL", label: "Florida", id: 6 })
    );

    const source = searchParams.get("source");
    const referredBy = searchParams.get("referred_by");
    if (source || referredBy) {
      localStorage.setItem(
        "guestReferralData",
        JSON.stringify({
          referral_source: source || "",
          referred_by: referredBy || "",
        })
      );
    } else {
      localStorage.removeItem("guestReferralData");
    }
  }, [searchParams]);
}
